export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_10.5850d761.jpg";